window.QuestionBankAPI =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI("QuestionBankServers"));

    self.getBrandQuestionTypes = function (brandId, questionTypeFilter, serviceType) {

        var deferred = $q.defer();
        var payload = {};

        if (questionTypeFilter) {
            payload.filter_by = questionTypeFilter;
        }

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/questions/types', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveBrandQuestionTypes = function (brandId, questionsTypes, serviceType) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/questions/types', 'PUT', { types: questionsTypes })
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getSignedUrl = function (brandId, serviceType, param) {

        if (!brandId) {
            throw "No brand id";
        }

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/presigned_url', 'GET', param)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.postMedia = function (brandId, serviceType, param) {

        if (!brandId) {
            throw "No brand id";
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/media', 'POST', param)
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteMedia = function (brandId, serviceType, mediaId) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!serviceType) {
            throw "No service type";
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/media/' + mediaId, 'DELETE')
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getMedia = function (brandId, serviceType, payload) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!serviceType) {
            throw "No service type";
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/media', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getAllQuestions = function (brandId, offset, limit, types, searchTerm, serviceType) {

        var deferred = $q.defer();

        var payload = {};

        if (offset !== null || typeof (offset) !== 'undefined') {
            payload.offset = offset;
        }

        if (limit) {
            payload.limit = limit;
        }

        if (types) {
            payload.types = types;
        }

        if (searchTerm) {
            payload.search_term = searchTerm;
        }

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/questions', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getQuestion = function (brandId, questionId, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/questions/' + questionId, 'GET')
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveQuestions = function (brandId, questions, serviceType) {

        var deferred = $q.defer();

        if (!brandId) {
            return console.error("Brand id is required");
        }

        var payload = {
            questions: questions
        };

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/questions', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateQuestion = function (brandId, questionId, questionData, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/questions/' + questionId, 'PUT', questionData)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteQuestion = function (brandId, questionId, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/questions/' + questionId, 'DELETE')
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.reorderQuestion = function (brandId, templateId, questionId, order, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/templates/' + templateId + '/questions/' + questionId + '/reorder', 'POST', { order: order })
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.startEvaluation = function (brandId, applicationId, templateId, type, serviceType) {

        var deferred = $q.defer();

        var payload = {
            type: type
        };

        if (templateId) {
            payload.template_id = templateId;
        }

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/' + applicationId + '/evaluations', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveEvaluation = function (brandId, applicationId, evaluationId, status, answers, serviceType) {

        var deferred = $q.defer();

        var payload = {
            status: status,
            answers: answers
        };

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/' + applicationId + '/evaluations/' + evaluationId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateEvaluationQuestionAnswers = function (brandId, applicationId, evaluationId, questionId, payload, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/' + applicationId + '/evaluations/' + evaluationId + '/questions/' + questionId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEvaluationDetails = function (brandId, applicationId, evaluationId, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/' + applicationId + '/evaluations/' + evaluationId, 'GET')
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEvaluationResults = function (brandId, applicationId, type, serviceType) {

        var deferred = $q.defer();

        var params = {
            type: type
        };

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/' + applicationId + '/evaluations', 'GET', params)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getJobAttachedTemplates = function (brandId, jobId, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/jobs/' + jobId + '/templates', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {

                    deferred.resolve(res.data.data.templates);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getAllTemplates = function (brandId, limit, offset, types, positions, searchTerm, brandIds, filterBy, statuses, serviceType, includeArchived) {

        var deferred = $q.defer();

        var payload = {};

        if (offset) {
            payload.offset = offset;
        }

        if (limit) {
            payload.limit = limit;
        }

        if (types && types.length) {
            payload.types = types;
        }

        if (positions && positions.length) {
            payload.positions = positions
        }

        if (searchTerm) {
            payload.search_term = searchTerm;
        }

        if (brandIds && brandIds.length) {
            payload.brand_ids = brandIds;
        }

        if (filterBy) {
            payload.filter_by = filterBy;
        }

        if (statuses && statuses.length) {
            payload.statuses = statuses;
        }

        if (includeArchived) {
            payload.include_archived = includeArchived;
        }

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/templates', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveTemplates = function (brandId, payload, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/templates', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editTemplates = function (brandId, templateId, payload, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/templates/' + templateId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteTemplate = function (brandId, templateId, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/templates/' + templateId, 'DELETE')
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTemplateById = function (brandId, templateId, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/templates/' + templateId, 'GET')
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // get job and phone results
    self.getQuestionBankApplicationsStatuses = function (brandId, applicationIds, loadPrevApps) {
        var deferred = $q.defer();

        var params = {
            ids: applicationIds
        };

        if (loadPrevApps) {
            params.load_previous_applications = loadPrevApps;
        }

        _protected.request('brands/' + brandId + '/services/' + 'QUESTION_BANK' + '/applications/statuses', 'GET', params)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPhoneApplicationsStatuses = function (brandId, type, applicationIds) {

        var deferred = $q.defer();

        var params = {
            type: type,
            ids: applicationIds
        };

        _protected.request('brands/' + brandId + '/services/' + 'QUESTION_BANK' + '/applications/statuses', 'GET', params)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandQuestionBankSettings = function (brandId, params, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/settings', 'GET', params)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getMyVideoInterviews = function (payload, serviceType) {

        var deferred = $q.defer();

        _protected.request('users/' + 'services/' + serviceType + '/applications/interviews', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveBrandQuestionBankJobTemplates = function (brandId, jobId, jobInterviewTemplates, serviceType) {

        var deferred = $q.defer();

        var payload = {
            templates: jobInterviewTemplates
        };

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/jobs/' + jobId + '/templates', 'PUT', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.activateTemplate = function (brandId, templateId, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/templates/' + templateId + '/activate', 'POST')
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deactivateTemplate = function (brandId, templateId, serviceType) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/templates/' + templateId + '/deactivate', 'POST')
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.sendVideoInterviewInvitation = function (brandId, serviceType, appIds) {

        var deferred = $q.defer();

        var payload = {
            application_ids: appIds
        };

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/interviews/send', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.resendVideoInterviewInvitation = function (brandId, serviceType, applicationId, interviewId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/' + applicationId + '/interviews/' + interviewId + '/resend', 'POST')
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.withdrawVideoInterviewInvitation = function (brandId, serviceType, interviewIds) {

        var deferred = $q.defer();

        var payload = {
            interview_ids: interviewIds
        };

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/interviews/withdraw', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.postOverAllScore = function (brandId, serviceType, applicationId, interviewId, payload) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/' + applicationId + '/interviews/' + interviewId +'/score', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.postReview = function (brandId, serviceType, applicationId, interviewId, questionId, answerId, payload) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/' + applicationId + '/interviews/' + interviewId + '/questions/' + questionId + '/answers/' + answerId + '/score', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getVideoInterviewReviewers = function (brandId, serviceType, applicationId, interviewId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/' + applicationId + '/interviews/' + interviewId + '/reviewers', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getVideoInterviewStatuses = function (brandId, serviceType, appsIds) {

        var payload = {
            ids: appsIds
        };

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/statuses', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getApplicantInterview = function (brandId, serviceType, applicationId) {

        var deferred = $q.defer();

        var payload = {
            condition: 'ACTIVE'
        };

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/applications/' + applicationId + '/interviews', 'GET', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.data.interviews) {
                    deferred.resolve(res.data.data.interviews[0]);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // Candidate - video apis
    self.getCandidateInterviews = function (statuses) {

        var deferred = $q.defer();
        _protected.request('candidates/services/VIDEO_INTERVIEW/applications/interviews', 'GET', {statuses: statuses})
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getInterview = function (applicationId, interviewId) {

        var deferred = $q.defer();
        var url = 'candidates/services/VIDEO_INTERVIEW/applications/' + applicationId + '/interviews/' + interviewId;
        _protected.request(url, 'GET')
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.startInterview = function (applicationId, interviewId) {

        var deferred = $q.defer();
        var url = 'candidates/services/VIDEO_INTERVIEW/applications/' + applicationId + '/interviews/' + interviewId + '/start';
        _protected.request(url, 'POST')
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.interviewQuestionRetried = function (applicationId, interviewId, questionId) {

        var deferred = $q.defer();
        var url = 'candidates/services/VIDEO_INTERVIEW/applications/' + applicationId + '/interviews/' + interviewId + '/questions/' + questionId + '/retry';
        _protected.request(url, 'POST')
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.answerInterviewQuestion = function (applicationId, interviewId, questionId, payload) {

        var deferred = $q.defer();
        var url = 'candidates/services/VIDEO_INTERVIEW/applications/' + applicationId + '/interviews/' + interviewId + '/questions/' + questionId + '/answer';
        _protected.request(url, 'POST', payload)
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.keepInterviewAlive = function (applicationId, interviewId) {

        var deferred = $q.defer();
        var url = 'candidates/services/VIDEO_INTERVIEW/applications/' + applicationId + '/interviews/' + interviewId + '/keep_alive';
        _protected.request(url, 'POST')
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.withdrawInterview = function (applicationId, interviewId) {
        var deferred = $q.defer();
        var url = 'candidates/services/VIDEO_INTERVIEW/applications/' + applicationId + '/interviews/' + interviewId + '/withdraw';
        _protected.request(url, 'POST')
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getVideoInterviewBrandReviewers = function (brandId) {
        var deferred = $q.defer();
        var url = '/brands/'+brandId+'/services/VIDEO_INTERVIEW/reviewers';
        _protected.request(url, 'GET')
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.STATUSES = {
        SENDING: 'SENDING',
        EXPIRED: 'EXPIRED',
        IN_PROGRESS: 'IN_PROGRESS',
        NOT_STARTED: 'NOT_STARTED',
        INVITED: 'INVITED',
        INCOMPLETE: 'INCOMPLETE',
        INTERVIEWED: 'INTERVIEWED',
        PENDING_REVIEW: 'PENDING_REVIEW',
        REMINDER_SENT: 'REMINDER_SENT',
        WITHDRAWN: 'WITHDRAWN',
        CANDIDATE_WITHDRAWN: 'CANDIDATE_WITHDRAWN'
    };

    self.STATUSES_WEIGHT = {
        'INTERVIEWED': 11,
        'PENDING_REVIEW': 10,
        'IN_PROGRESS': 9,
        'REMINDER_SENT': 8,
        'INVITED': 7,
        'INCOMPLETE': 6,
        'CANDIDATE_WITHDRAWN': 5,
        'WITHDRAWN': 4,
        'EXPIRED': 3,
        'SENDING': 2,
        'NOT_STARTED': 1,
    };

    self.STATUSES_TEXT = {
        EXPIRED: {
            text: $filter('translate')('Invite expired'),
            color: 'text-danger',
            icon: 'fa-times-circle',
        },
        IN_PROGRESS: {
            text: $filter('translate')('Screening in progress'),
            color: 'text-warning',
            icon: 'fa-exclamation-circle',
        },
        NOT_STARTED: {
            text: $filter('translate')('Invitation not sent'),
            color: 'text-danger',
            icon: 'fa-times-circle',
        },
        INVITED: {
            text: $filter('translate')('Screening sent'),
            color: 'text-primary',
            icon: 'fa-exclamation-circle',
        },
        INCOMPLETE: {
            text: $filter('translate')('Screening incomplete'),
            color: 'text-danger',
            icon: 'fa-exclamation-circle',
        },
        INTERVIEWED: {
            text: $filter('translate')('Complete - Reviewed'),
            color: 'text-success',
            icon: 'fa-check',
        },
        PENDING_REVIEW: {
            text: $filter('translate')('Complete') + ' - ' + $filter('translate')('Needs review'),
            color: 'text-warning',
            icon: 'fa-exclamation-circle',
        },
        REMINDER_SENT: {
            text: $filter('translate')('Reminder sent'),
            color: 'text-primary',
            icon: 'fa-exclamation-circle',
        },
        WITHDRAWN: {
            text: $filter('translate')('Screening withdrawn'),
            color: 'text-danger',
            icon: 'fa-exclamation-circle',
        },
        CANDIDATE_WITHDRAWN: {
            text: $filter('translate')('Candidate withdrawn'),
            color: 'text-danger',
            icon: 'fa-exclamation-circle',
        },
        SENDING: {
            text: $filter('translate')('Sending'),
            color: 'text-warning',
            icon: 'fa-exclamation-circle',
        },
    };

};

